import React from 'react';
import { Card, CardContent, makeStyles, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  bannerContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(5px)',
  },
  banner: {
    margin: theme.spacing(1),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(1),
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
    },
  },
  bannerContent: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    position: 'relative',
    '&:last-child': {
      paddingBottom: theme.spacing(1),
    },
  },
  bannerImage: {
    width: '60px',
    height: '60px',
    objectFit: 'cover',
    borderRadius: theme.spacing(0.5),
    marginRight: theme.spacing(2),
  },
  bannerText: {
    flex: 1,
  },
  bannerTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: theme.spacing(0.5),
  },
  bannerSubtitle: {
    fontSize: '14px',
    color: '#666',
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: theme.spacing(0.5),
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
}));

const AdBanner = ({ onClose, onClick }) => {
  const classes = useStyles();

  const handleBannerClick = (e) => {
    // Don't trigger banner click if close button was clicked
    if (e.target.closest('.close-button')) {
      return;
    }
    if (onClick) {
      onClick();
    }
  };

  const handleCloseClick = (e) => {
    e.stopPropagation();
    if (onClose) {
      onClose();
    }
  };

  return (
    <aside className={classes.bannerContainer} aria-label="Advertisement">
      <Card
        className={classes.banner}
        onClick={handleBannerClick}
        role="link"
        tabIndex={0}
        aria-label="Dating Simulator: learn how to date anyone, anytime, anywhere (opens Google Play)"
        onKeyDown={(e) => {
          if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('.close-button')) {
            e.preventDefault();
            handleBannerClick(e);
          }
        }}
      >
        <CardContent className={classes.bannerContent}>
          <img 
            src="/banner.jpg" 
            alt="InstantDate App" 
            className={classes.bannerImage}
            onError={(e) => {
              // Fallback if image doesn't load
              e.target.style.display = 'none';
            }}
          />
          <div className={classes.bannerText}>
            <div className={classes.bannerTitle}>
              Dating Simulator
            </div>
            <div className={classes.bannerSubtitle}>
              Learn how to date anyone, anytime, anywhere.
            </div>
          </div>
          <IconButton 
            className={`${classes.closeButton} close-button`}
            onClick={handleCloseClick}
            size="small"
            aria-label="Close ad"
          >
            <CloseIcon />
          </IconButton>
        </CardContent>
      </Card>
    </aside>
  );
};

export default AdBanner; 